<template>
  <div class="y-navbar" :class="{ fixed }">
    <div class="y-navbar-inner">
      <responsive-logo
        :src="channel?.logoDetail?.rectangle || channel?.logo"
        :horizontal="{
          container: { width: '140px', height: '32px' },
          image: { maxWidth: '140px', maxHeight: '32px' }
        }"
        position="top-left"
        :vertical="{
          container: { height: '36px' },
          image: { maxHeight: '36px' }
        }"
        @click="handleClick"
      />
      <div class="y-navbar-middle" v-if="showSearch">
        <search-bar
          class="search-bar"
          :show-label="false"
          :scroll="false"
          @on-change="handleOnFilterChange"
          :locationDisabled="locationDisabled"
        />
      </div>
      <div class="y-navbar-right flex items-center">
        <div class="mr-5" v-if="showLanguage">
          <language-selector
            v-model="language"
            :use-channel-languages="useChannelLanguages"
            @change="handleOnLanguageChange"
          />
        </div>
        <y-current-user
          size="small"
          type="primary"
          :custom-user="customUser"
          :settings="headerSettings"
          :show-divider="showLanguage"
          @member="hanldeSetMember"
        />
      </div>
    </div>
    <div class="y-navbar-bottom">
      <div class="y-navbar-shadow" />
      <div class="breadcrumb-box" v-if="showBreadcrumb">
        <y-breadcrumb :routes="routes" theme="default" />
      </div>
    </div>
    <user-hl-member :settings="headerSettings" v-model:show="memberDrawer" />
  </div>
</template>

<script setup>
import YCurrentUser from "@packages/user/CurrentUser/index.vue";
import LanguageSelector from "@packages/user/LanguageSelector.vue";
import UserHlMember from "@packages/user/memberUseDrawer/index.vue";
import YBreadcrumb from "@ui/Breadcrumb/index.vue";
import ResponsiveLogo from "@ui/ResponsiveLogo/index.vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useChannelStoreHook } from "@/store/modules/channel";
import { useUserStoreHook } from "@/store/modules/user";

import SearchBar from "../../components/SearchBar/index.vue";
import { headerSettings } from "../../config/index";
import { useYChannelStoreHook } from "../../store/channel";
defineProps({
  showSearch: {
    type: Boolean,
    default: true
  },
  locationDisabled: {
    type: Boolean,
    default: false
  },
  showLanguage: {
    type: Boolean,
    default: true
  },
  fixed: {
    type: Boolean,
    default: true
  },
  showBreadcrumb: Boolean,
  routes: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(["on-search"]);
const router = useRouter();
const userStore = useUserStoreHook();
const channelStore = useYChannelStoreHook();
const { language } = storeToRefs(userStore);
const { configs } = storeToRefs(channelStore);
const { channel } = useChannelStoreHook();

const memberDrawer = ref(false);

const useChannelLanguages = computed(() => {
  return configs.value?.useChannelLanguages || false;
});

const customUser = computed(() => {
  return configs.value?.customUser;
});

const hanldeSetMember = async () => {
  memberDrawer.value = true;
};

const handleOnLanguageChange = locale => {
  userStore.changeLanguage(locale);
};
const handleClick = () => {
  router.push("/");
};

const handleOnFilterChange = () => {
  emit("on-search");
};
</script>
<style lang="scss" scoped>
.y-navbar {
  --y-language-selector-color: var(--y-title-text-color);
  --y-language-selector-size: 16px;
  width: 100%;
  height: 52px;
  color: #fff;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 22;
  }

  .y-navbar-inner {
    max-width: 1920px;
    margin: 0 auto;
    width: 100%;
    min-width: 1080px;
    height: 52px;
    background: #ffffff;
    color: var(--y-brand-btn-color);
    padding: 0 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .y-navbar-middle {
      --search-bar-inner-width: 100%;
      --y-filter-travelers-size: 16px;
      width: 960px;
      display: flex;
      align-items: center;
      :deep(.y-datepicker) {
        --y-datepicker-date-label-size: 16px;
        .content-show-label {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          .text-date {
            margin-right: 0;
            white-space: nowrap;
          }
        }
      }
      :deep(.search-bar) {
        .search-bar-inner {
          padding: 0;
          height: 100%;
          justify-content: flex-start;

          .el-divider {
            margin: 0 48px;
            height: 48px;
          }
          .btn {
            --y-button-width: 140px;
            --y-button-height: 44px;
            margin-left: 96px;
          }
        }
      }
    }
  }
  .y-navbar-bottom {
    position: relative;
    background: #fff;
    .y-navbar-shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.06) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
    .breadcrumb-box {
      width: 1080px;
      // padding: 24px 0 30px 0;
      padding: 18px 0 30px 0;
      margin: 0 auto;
      position: relative;
      z-index: 2;
    }
  }
}
@media screen and (max-width: 1440px) {
  .y-navbar {
    .y-navbar-inner {
      padding: 16px 28px;
      .y-navbar-middle {
        width: 672px;
        :deep(.search-bar) {
          .search-bar-inner {
            justify-content: space-between;
            .el-divider {
              margin: 0 20px;
              height: 40px;
            }
            .btn {
              margin-left: 40px;
            }
          }
        }
        :deep(.location-selector) {
          width: 156px;
        }
      }
    }
  }
}
</style>
